import React from 'react'
import Feedback from '../feedback'

const FeedbackDe = () => {
    return <Feedback languageCode="de" />
}

export default FeedbackDe
